module.exports = __webpack_public_path__ + "a643bf4c1695b21bc47300a3ea8fa6d8.svg";